import React from "react";
import { DynamicTag } from "@montana/shared/dynamic-tag";

// An elegant component for a more civilized age...
// Simply handles setting a string as innerHTML (to support &#173; &shy; etc.) plus adds
// styles for CSS auto hyphenation (if supported) and word break.

interface ISoftHyphensProps {
    text?: string;
    className?: string;
    tagName?: string;
}

export const SoftHyphens: React.FC<ISoftHyphensProps> = React.memo((props: ISoftHyphensProps): JSX.Element | null => {
    const {
        text,
        className,
        tagName,
    } = props;

    if (!text) {
        return null;
    }

    return (
        <DynamicTag type={tagName} className={`soft-hyphens${className ? ` ${className.trim()}` : ''}`} dangerouslySetInnerHTML={{ __html: text }}>
        </DynamicTag>
    )
});
